/**
 * Formats the given value into a (maybe partially entered) zip code.
 */
export const formatZipCode = (value: string): string => {
  const digits = value.replace(/[^\d]/g, '');
  if (digits.length > 5) {
    return `${digits.substring(0, 5)}-${digits.substring(5)}`;
  }
  return digits;
};
